// mixins/FirebaseActions.js
import { mapGetters, mapMutations } from "vuex";
import Utility from "@/mixins/Utility.js";
import googleAnalytics from "@/mixins/googleAnalytics.js";
import cleverTap from "@/mixins/clevertap.js";
import common from "@/mixins/common.js";
import { _clientKey } from "./../provider-config.js";
import { store } from "@/store/store";
import { getDatabase, ref, get, update, remove } from "firebase/database";
import { getAuth, signInAnonymously } from "firebase/auth";

import { 
  doc, 
  setDoc, 
  updateDoc, 
  getDoc, 
  collection, 
  serverTimestamp 
} from "firebase/firestore";

export default {
  data() {
    return {
      filteredAvailabilities: [],
      pricemodel: null,
      availabilities: [],
    };
  },
  computed: {
    ...mapGetters([
      "subscriberid",
      "profileid",
      "availabilityList",
      "getFirebaseUserUID",
    ]),
  },
  methods: {
    ...mapMutations(["setFirebaseUserUID"]),

    /** ----------------------- AUTH & USER ----------------------- **/
    /** ---------------- ANONYMOUS LOGIN ---------------- **/
async firebaseAnonymousLogin() {
  try {
    const auth = getAuth();
    const result = await signInAnonymously(auth);
    const uid = result.user.uid;

    this.firebaseStoreUser(uid);
    this.setFirebaseUserUID(uid);
  } catch (err) {
    console.error("Anonymous login error:", err);
  }
},

/** ---------------- STORE USER ---------------- **/
async firebaseStoreUser(uid) {
  try {
    const db = getDatabase();
    let secretKey = _clientKey.slice(0, -3);
    const path = `/${secretKey}`;

    const obj = { [uid]: this.subscriberid };
    await update(ref(db, path), obj);

    console.log("LOGIN DATA SUCCESSFULLY WRITTEN");
  } catch (err) {
    console.error("firebaseStoreUser error:", err);
  }
},

/** ---------------- REMOVE USER ---------------- **/
async firebaseRemoveUser() {
  try {
    const db = getDatabase();
    let secretKey = _clientKey.slice(0, -3);
    const path = `/${secretKey}/${this.getFirebaseUserUID}`;

    await remove(ref(db, path));
    console.log("Firebase user removed successfully");
  } catch (err) {
    console.error("firebaseRemoveUser error:", err);
  }
},

/** ---------------- FETCH LIKE/DISLIKE COUNT ---------------- **/
async fetchLikeDislikeCount(data) {
  try {
    const db = getDatabase();
    const path = `content/${data.objectid}/${data.type}/count`;
    const snapshot = await get(ref(db, path));

    const count = snapshot.val() || 0;
    if (data.type === "like") this.likeCount = count;
    else this.dislikeCount = count;

    return count;
  } catch (err) {
    console.error("fetchLikeDislikeCount error:", err);
    return 0;
  }
},

/** ---------------- FETCH CONTENT INFO ---------------- **/
async fetchContentInfoFromFireBase(content) {
  try {
    const db = getDatabase();
    const path = `/subscriber/${this.subscriberid}/${this.profileid}/content/${content.objectid}`;
    const snapshot = await get(ref(db, path));

    return snapshot.exists() ? snapshot.val() : null;
  } catch (err) {
    console.error("fetchContentInfoFromFireBase error:", err);
    return null;
  }
},

/** ---------------- CHECK FIRE DATA EXISTS ---------------- **/
async checkFireDataExists(path) {
  try {
    const db = getDatabase();
    const snapshot = await get(ref(db, path));
    return snapshot.exists();
  } catch (err) {
    console.error("checkFireDataExists error:", err);
    return false;
  }
},

    /** ----------------------- CONTENT UPDATES ----------------------- **/
    async updateContentCount(content, countData, clicked, changeData) {
      if (!content || !content.objectid) return;

      const db = getDatabase();
      const path = `content/${content.objectid}`;
      const subscriberPath = `/subscriber/${this.subscriberid}/${this.profileid}/content/${content.objectid}`;

      const pathRef = ref(db, path);
      const subscriberRef = ref(db, subscriberPath);

      // 🔍 Check if content node exists
      const snapshot = await get(pathRef);
      const exists = snapshot.exists();

      if (!exists) {
        await putCountData();
      } else {
        await updateCountData();
      }

      /** ------------------ CREATE COUNT DATA ------------------ **/
      async function putCountData() {
        const data = {
          like: { count: 0 },
          dislike: { count: 0 },
        };

        if (clicked === "LIKE") {
          data.like.count = 1;
          data.dislike.count = 0;
        } else if (clicked === "DISLIKE") {
          data.like.count = 0;
          data.dislike.count = 1;
        }

        try {
          await set(pathRef, data);
          console.log("✅ Initial like/dislike count created:", data);
        } catch (err) {
          console.error("❌ Error setting count data:", err);
        }
      }

      /** ------------------ UPDATE COUNT DATA ------------------ **/
      async function updateCountData() {
        let contentState = "";

        try {
          const subSnap = await get(subscriberRef);
          if (subSnap.exists()) {
            contentState = subSnap.val()?.likestatus || "";
          }
        } catch (err) {
          console.warn("⚠️ Error reading subscriber content:", err);
        }

        let countObj = {};

        if (clicked === "LIKE") {
          countObj = { like: { count: countData + 1 } };
        }
        else if (clicked === "LIKE" && contentState === "DISLIKE" && changeData !== undefined) {
          countObj = {
            like: { count: countData + 1 },
            dislike: { count: Math.max(changeData - 1, 0) },
          };
        }
        else if (clicked === "DISLIKE" && contentState === "LIKE" && changeData !== undefined) {
          countObj = {
            like: { count: Math.max(changeData - 1, 0) },
            dislike: { count: countData + 1 },
          };
        }
        else if (clicked === "REMOVELIKE") {
          countObj = { like: { count: Math.max(countData - 1, 0) } };
        }
        else if (clicked === "DISLIKE") {
          countObj = { dislike: { count: countData + 1 } };
        }
        else if (clicked === "REMOVEDISLIKE") {
          countObj = { dislike: { count: Math.max(countData - 1, 0) } };
        }

        try {
          await update(pathRef, countObj);
          console.log("✅ Like/Dislike count updated:", countObj);
        } catch (err) {
          console.error("❌ Error updating count data:", err);
        }
      }
    },

    async updateLikeDislikeToFire(content, status) {
      if (!content || !status) return;

      const db = getDatabase();
      let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
      localDisplayLang = localDisplayLang === "ml" ? "mal" : localDisplayLang;

      this.cleverTapUpdate(content, status);

      // Build Firebase path
      let path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;
      if ("seriesid" in content && content.seriesid) {
        path += `${content.seriesid}/episodes/${content.objectid}`;
      } else {
        path += `${content.objectid}`;
      }

      const contentRef = ref(db, path);

      // 🔍 Check if data exists
      const snapshot = await get(contentRef);
      const exists = snapshot.exists();

      if (!exists) {
        await putData();
      } else {
        await updateData(snapshot.val());
      }

      /** ---------------- PUT DATA ---------------- **/
      async function putData() {
        let landscapeImage = "";
        let portraitImage = "";
        let squareImage = "";

        if (Array.isArray(content.poster)) {
          const landscapeIndex = content.poster.findIndex(el => el.postertype === "LANDSCAPE");
          if (
            landscapeIndex > -1 &&
            content.poster[landscapeIndex]?.filelist?.[2]?.filename
          ) {
            landscapeImage = content.poster[landscapeIndex].filelist[2].filename;
          }
        }

        const data = {
          objectid: content.objectid || "",
          contentstatus: "ACTIVE",
          title: content.title || "",
          objecttype: content.objecttype || "",
          duration: content.duration ? parseInt(content.duration) : 0,
          poster: {
            landscape: landscapeImage || "",
            portrait: portraitImage || "",
            square: squareImage || "",
          },
          likestatus: status,
          genre: content.genre || "",
          seasoncount: content.seasoncount || 1,
          displaylanguage: localDisplayLang || "",
        };

        if ("seriesid" in content && content.seriesid) {
          data.seriesid = content.seriesid;
          data.seasonnum = content.seasonnum || "";
          data.episodenum = content.episodenum || "";
        }

        try {
          await update(contentRef, data);
          console.log("Like/Dislike created successfully");
        } catch (error) {
          console.error("Error writing like/dislike data:", error);
        }

        try {
          this.userActionEvent({ action_name: status });
        } catch (err) {
          console.warn("GA event error:", err);
        }
      }

      /** ---------------- UPDATE DATA ---------------- **/
      async function updateData(prevData) {
        let updatedStatus = "NONE";
        const prevStatus = prevData?.likestatus;

        if (status === "LIKE") {
          updatedStatus =
            prevStatus === "LIKE"
              ? "NONE"
              : prevStatus === "DISLIKE"
                ? "LIKE"
                : "LIKE";
        } else if (status === "DISLIKE") {
          updatedStatus =
            prevStatus === "LIKE"
              ? "DISLIKE"
              : prevStatus === "DISLIKE"
                ? "NONE"
                : "DISLIKE";
        } else if (status === "NONE") {
          updatedStatus = "NONE";
        }

        try {
          await update(contentRef, { likestatus: updatedStatus });
          console.log("Like/Dislike updated successfully:", updatedStatus);
        } catch (error) {
          console.error("Error updating like/dislike data:", error);
        }

        try {
          this.userActionEvent({ action_name: status });
        } catch (err) {
          console.warn("GA event error:", err);
        }
      }
    },

    async updateContentWatchlist(content, status) {
      if (!content) return;

      const db = getDatabase(); // initialized Firebase app
      const path = `/subscriber/${this.subscriberid}/${this.profileid}/content/${content.objectid}`;
      const contentRef = ref(db, path);

      let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
      localDisplayLang = localDisplayLang === "ml" ? "mal" : localDisplayLang;

      let landscapeImage = "";
      let portraitImage = "";
      let squareImage = "";

      if (Array.isArray(content.poster)) {
        const landscapeIndex = content.poster.findIndex(el => el.postertype === "LANDSCAPE");
        const portraitIndex = content.poster.findIndex(el => el.postertype === "PORTRAIT");
        const squareIndex = content.poster.findIndex(el => el.postertype === "SQUARE");

        if (landscapeIndex > -1)
          landscapeImage = content.poster[landscapeIndex]?.filelist?.[1]?.filename || "";

        if (portraitIndex > -1)
          portraitImage = content.poster[portraitIndex]?.filelist?.[1]?.filename || "";

        if (squareIndex > -1)
          squareImage = content.poster[squareIndex]?.filelist?.[1]?.filename || "";
      }

      const data = {
        objectid: content.objectid || "",
        objecttype: content.objecttype || "",
        category: content.category || "",
        title: content.title || "",
        updatedat: Math.floor(Date.now() / 1000),
        poster: {
          landscape: landscapeImage,
          portrait: portraitImage,
          square: squareImage,
        },
        genre: content.genre || "",
        contentstatus: "ACTIVE",
        duration: content.duration ? parseInt(content.duration) : 0,
        inwatchlist: status,
        displaylanguage: localDisplayLang || "",
      };

      if (content.category === "TVSHOW" && content.seasoncount) {
        data.seasoncount = content.seasoncount;
      }

      return update(contentRef, data)
        .then(() => {
          console.log("Watchlist updated successfully");
        })
        .catch((error) => {
          console.error("Error updating watchlist:", error);
        });
    },

    async updateContinueWatch(content, watchStatus, watchDuration) {
      if (!content) return;

      const localDisplayLang = (localStorage.getItem("setDisplayLanguageCode") || "en").replace('ml', 'mal');
      const nextepisodeid = localStorage.getItem("nextepisodeid");

      let path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;

      if ("seriesid" in content && content.seriesid) {
        path += `${content.seriesid}/episodes/${content.objectid}`;
      } else {
        path += `${content.objectid}`;
      }

      // Build poster images
      let landscapeImage = "", portraitImage = "", squareImage = "";
      if (Array.isArray(content.poster)) {
        const landscapeIndex = content.poster.findIndex(p => p.postertype === "LANDSCAPE");
        const portraitIndex = content.poster.findIndex(p => p.postertype === "PORTRAIT");
        const squareIndex = content.poster.findIndex(p => p.postertype === "SQUARE");

        if (landscapeIndex > -1 && content.poster[landscapeIndex]?.filelist?.[2]) {
          landscapeImage = content.poster[landscapeIndex].filelist[2].filename;
        }
        if (portraitIndex > -1 && content.poster[portraitIndex]?.filelist?.[2]) {
          portraitImage = content.poster[portraitIndex].filelist[2].filename;
        }
        if (squareIndex > -1 && content.poster[squareIndex]?.filelist?.[2]) {
          squareImage = content.poster[squareIndex].filelist[2].filename;
        }
      } else {
        landscapeImage = content.poster?.landscape || "";
        portraitImage = content.poster?.portrait || "";
      }

      // Build data object
      const data = {
        objectid: content.objectid || "",
        objecttype: content.objecttype || "",
        category: content.category || "",
        genre: content.genre || "",
        title: content.title || "",
        updatedat: Math.floor(Date.now() / 1000),
        poster: { landscape: landscapeImage, portrait: portraitImage, square: squareImage },
        status: watchStatus,
        contentstatus: "ACTIVE",
        duration: content.duration ? parseInt(content.duration) : 0,
        watchedduration: watchStatus === "INPROGRESS" ? watchDuration : null,
        displaylanguage: localDisplayLang,
      };

      if ("seriesid" in content && content.seriesid) {
        data.seriesid = content.seriesid;
        data.seasonnum = content.seasonnum;
        data.episodenum = content.episodenum;
        data.nextepisodeid = nextepisodeid || "";
      }

      try {
        const db = getDatabase(); // default app
        const contentRef = ref(db, path);
        await update(contentRef, data);
      } catch (err) {
        console.error("updateContinueWatch error:", err);
      }
    },

    async removeFromContinueWatch(content) {
      if (!content) return;

      const db = getDatabase(); // your initialized app’s Realtime DB
      let path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;

      // Handle series and movies differently
      if ("seriesid" in content && content.seriesid) {
        path += `${content.seriesid}/episodes/${content.objectid}`;
      } else {
        path += `${content.objectid}`;
      }

      const contentRef = ref(db, path);

      // Option 1: Remove only watchedduration and status fields
      const updates = {
        watchedduration: null,
        status: null,
      };
      update(contentRef, updates)
        .then(() => {
          console.log("Continue watch fields removed successfully");
        })
        .catch((error) => {
          console.error("Error removing continue watch:", error);
        });

      // Option 2: If you actually want to delete the entire content node:
      // remove(contentRef)
      //   .then(() => console.log("Content removed from continue watch"))
      //   .catch((error) => console.error("Error removing content:", error));
    },

    /** ----------------------- HELPER / SDK ----------------------- **/
    cleverTapUpdate(content, status) {
      if (this.availabilityList) this.availabilities = this.availabilityList;

      const data = {
        content_id: content.objectid,
        content_title: content.title,
        content_type: content.objecttype,
        content_genre: content.genre,
        content_language: content.contentlanguage?.[0],
        partner_id: content.partnerid || "",
        content_duration: content.duration,
        content_price: this.pricemodel === "FREE" ? "Free" : "Paid",
        rating: status,
      };

      // CleverTap event
      this.ratedCleverTapEvent(data);

      // Google Analytics event
      this.ratedEvent(data);
    },

    vLiveSDKContentLikeDislike(content, LikeCount, DislikeCount) {
      if (!window.vLiveWebSdk) return;
      const data = {
        EventCategory: "CONTENT",
        Event: "LikeDislike",
        ContentID: content.contentid,
        LikeCount,
        DislikeCount,
      };
      window.vLiveWebSdk.put(data);
    },
  },

  mixins: [Utility, googleAnalytics, cleverTap, common],
};
